import axiosInstance from "../utils/ApiUtils/axiosInstance";

export type BulkValidateLabelsParams = {
  translationId: number;
  labelIds: number[];
};

export type BulkValidationLabelResult = {
  labelId: number;
  status: string;
  reason?: string;
};

export type BulkValidationReport = {
  validated: number;
  rejected: number;
  skipped: number;
  labels: BulkValidationLabelResult[];
};

// POST /api/label/{translationId}/validate/bulk with body { labelIds }.
export const bulkValidateLabels = async ({
  translationId,
  labelIds,
}: BulkValidateLabelsParams): Promise<BulkValidationReport> => {
  const response = await axiosInstance.post<ApiResponse<BulkValidationReport>>(
    `/api/label/${translationId}/validate/bulk`,
    { labelIds }
  );

  return response.data.data as BulkValidationReport;
};

